(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    (function () {
    var SORT = '[data-collection-sort]';

    /*
     * Delegated rather than bound to the elements. Sorting swaps the whole
     * collection root, toolbar included, so anything holding references to
     * these nodes would be listening to detached elements afterwards.
     */
    function part(root, selector) {
      return root.querySelector(selector);
    }

    function options(root) {
      return Array.prototype.slice.call(
        root.querySelectorAll('[data-collection-sort-menu] [role="option"]')
      );
    }

    function isOpen(root) {
      var trigger = part(root, '[data-collection-sort-trigger]');
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    function open(root, index) {
      part(root, '[data-collection-sort-menu]').classList.remove('hidden');
      part(root, '[data-collection-sort-trigger]').setAttribute('aria-expanded', 'true');
      var all = options(root);
      var selected = part(root, '[data-collection-sort-menu] [aria-selected="true"]');
      var target = index == null ? selected || all[0] : all[index];
      if (target) target.focus();
    }

    function close(root, restoreFocus) {
      part(root, '[data-collection-sort-menu]').classList.add('hidden');
      part(root, '[data-collection-sort-trigger]').setAttribute('aria-expanded', 'false');
      if (restoreFocus) part(root, '[data-collection-sort-trigger]').focus();
    }

    function move(root, from, step) {
      var all = options(root);
      var index = all.indexOf(from);
      var next = index === -1 ? 0 : index + step;
      if (next < 0) next = all.length - 1;
      if (next >= all.length) next = 0;
      all[next].focus();
    }

    function choose(root, option) {
      if (!option) return;
      var form = root.closest('[data-collection-sort-form]');
      form.querySelector('[data-collection-sort-input]').value = option.dataset.value;
      options(root).forEach(function (entry) {
        entry.setAttribute('aria-selected', entry === option ? 'true' : 'false');
      });
      close(root, false);

      /*
       * Cancelable: the collection section swaps the grid in place and the
       * search section reloads with its category kept, and both call
       * preventDefault. With nothing listening this falls through to a normal
       * form submit, so sorting still works if that script is absent.
       */
      var event = new CustomEvent('collection:sort', {
        bubbles: true,
        cancelable: true,
        detail: { value: option.dataset.value },
      });
      if (root.dispatchEvent(event)) form.submit();
    }

    function rootFrom(target) {
      return target && target.closest ? target.closest(SORT) : null;
    }

    document.addEventListener('click', function (event) {
      var root = rootFrom(event.target);
      if (!root) {
        Array.prototype.forEach.call(document.querySelectorAll(SORT), function (open_) {
          if (isOpen(open_)) close(open_, false);
        });
        return;
      }
      if (event.target.closest('[data-collection-sort-trigger]')) {
        if (isOpen(root)) close(root, false);
        else open(root);
        return;
      }
      choose(root, event.target.closest('[role="option"]'));
    });

    document.addEventListener('keydown', function (event) {
      var root = rootFrom(event.target);
      if (!root) return;
      var option = event.target.closest('[role="option"]');

      if (event.target.closest('[data-collection-sort-trigger]')) {
        if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(root);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          open(root, options(root).length - 1);
        }
        return;
      }

      if (!option) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(root, option);
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        move(root, option, 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        move(root, option, -1);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close(root, true);
      } else if (event.key === 'Tab') {
        close(root, false);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-language-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-header-lang]');
    if (!roots.length) return;

    const normalizeRoot = (rootUrl) => {
      if (!rootUrl || rootUrl === '/') return '/';
      return rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
    };

    const stripLocalePrefix = (pathname, roots) => {
      let path = pathname || '/';
      const sorted = roots
        .map(normalizeRoot)
        .filter((r) => r && r !== '/')
        .sort((a, b) => b.length - a.length);

      for (const root of sorted) {
        if (path === root) return '/';
        if (path.startsWith(`${root}/`)) return path.slice(root.length) || '/';
      }
      return path;
    };

    const buildLocalizedUrl = (rootUrl, pathname, search, hash) => {
      const roots = Array.from(document.querySelectorAll('[data-header-lang-option]'))
        .map((el) => el.getAttribute('data-root-url'))
        .filter(Boolean);
      const suffix = stripLocalePrefix(pathname, roots);
      const base = normalizeRoot(rootUrl);
      if (base === '/') {
        return `${suffix}${search}${hash}`;
      }
      if (suffix === '/') {
        return `${base}/${search}${hash}`;
      }
      return `${base}${suffix}${search}${hash}`;
    };

    const closePanel = (root) => {
      const trigger = root.querySelector('[data-header-lang-trigger]');
      const panel = root.querySelector('[data-header-lang-list]');
      if (!trigger || !panel) return;
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
    };

    const closeAllExcept = (exceptRoot) => {
      roots.forEach((root) => {
        if (root !== exceptRoot) closePanel(root);
      });
    };

    roots.forEach((root) => {
      const form = root.querySelector('form.header-lang-form');
      const input = root.querySelector('[data-header-lang-input]');
      const trigger = root.querySelector('[data-header-lang-trigger]');
      const panel = root.querySelector('[data-header-lang-list]');
      if (!form || !input || !trigger || !panel) return;

      const togglePanel = () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeAllExcept(root);
        if (isOpen) {
          closePanel(root);
          return;
        }
        trigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      };

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        togglePanel();
      });

      root.querySelectorAll('[data-header-lang-option]').forEach((option) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();
          const code = option.getAttribute('data-value');
          const rootUrl = option.getAttribute('data-root-url');
          if (!code || code === input.value) {
            closePanel(root);
            return;
          }
          input.value = code;
          if (rootUrl) {
            const nextUrl = buildLocalizedUrl(
              rootUrl,
              window.location.pathname,
              window.location.search,
              window.location.hash
            );
            window.location.assign(nextUrl);
            return;
          }
          form.submit();
        });
      });

      root.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        closePanel(root);
        trigger.focus();
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-header-lang]')) return;
      roots.forEach((root) => closePanel(root));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luvora-image-preload"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.luvoraPreloadImageUrls) return;

    const loaded = new Set();

    const largestFromSrcset = (srcset) => {
      if (!srcset || typeof srcset !== 'string') return null;
      let bestUrl = null;
      let bestW = 0;
      srcset.split(',').forEach((part) => {
        const bits = part.trim().split(/\s+/);
        const url = bits[0];
        if (!url) return;
        const w = bits[1] && bits[1].endsWith('w') ? parseInt(bits[1], 10) : 0;
        if (w >= bestW) {
          bestW = w;
          bestUrl = url;
        }
      });
      return bestUrl;
    };

    const normalizeInput = (input) => {
      if (!input) return [];
      if (typeof input === 'string') return [input];
      if (Array.isArray(input)) return input;
      return [];
    };

    // Held so a pending preload cannot be garbage collected before it lands.
    const inFlight = new Set();

    const preload = (entry, priority) => {
      const key = entry.srcset ? entry.srcset + '|' + entry.sizes : entry.src;
      if (!key || loaded.has(key)) return;
      loaded.add(key);
      const img = new Image();
      img.decoding = 'async';
      img.fetchPriority = priority;
      // Same srcset + sizes as the real <img>, so the browser picks and caches
      // the width it will display rather than the largest one.
      if (entry.srcset) {
        img.sizes = entry.sizes;
        img.srcset = entry.srcset;
      } else {
        img.src = entry.src;
      }
      inFlight.add(img);
      const done = () => inFlight.delete(img);
      img.onload = done;
      img.onerror = done;
    };

    // `urgent` fetches now at high priority (the image a click is about to show);
    // everything else waits for idle time at low priority so it cannot compete.
    window.luvoraPreloadImageUrls = (inputs, { urgent = false } = {}) => {
      const pending = [];
      normalizeInput(inputs).forEach((item) => {
        if (!item) return;
        if (typeof item === 'string') {
          const fromSet = largestFromSrcset(item);
          pending.push({ src: fromSet || item });
          return;
        }
        if (item.srcset && item.sizes) {
          pending.push({ srcset: item.srcset, sizes: item.sizes });
          return;
        }
        if (item.src) pending.push({ src: item.src });
        if (item.srcset) {
          const fromSet = largestFromSrcset(item.srcset);
          if (fromSet) pending.push({ src: fromSet });
        }
      });

      if (urgent) {
        pending.forEach((entry) => preload(entry, 'high'));
        return;
      }

      // Background fetches are a guess at what comes next; on a metered or slow
      // connection, wait until the visitor actually asks for the image.
      const connection = navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

      const run = () => pending.forEach((entry) => preload(entry, 'low'));

      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 2500 });
      } else {
        setTimeout(run, 0);
      }
    };

    const collectProductCardUrls = (card) => {
      const urls = [];
      if (card.dataset.cardHoverImage) urls.push(card.dataset.cardHoverImage);
      card.querySelectorAll('[data-swatch-image]').forEach((swatch) => {
        const u = swatch.dataset.swatchImage;
        if (u) urls.push(u);
      });
      return urls;
    };

    // Swatch previews only exist under a mouse, so their images wait for one to enter
    // the card. Fetching them on sight competed with the card photos on screen and
    // cost touch devices images they could never show.
    window.luvoraPreloadProductCard = (card) => {
      if (!card || card.dataset.luvoraPreloadScheduled === '1') return;
      card.dataset.luvoraPreloadScheduled = '1';

      const onEnter = (event) => {
        if (event.pointerType !== 'mouse') return;
        card.removeEventListener('pointerenter', onEnter);
        const urls = collectProductCardUrls(card);
        if (urls.length) window.luvoraPreloadImageUrls(urls, { urgent: true });
      };
      card.addEventListener('pointerenter', onEnter);
    };

    window.luvoraThumbImageEntry = (thumb) => ({
      src: thumb.dataset.src || '',
      srcset: thumb.dataset.srcset || '',
      sizes: thumb.dataset.sizes || '',
    });

    // Nothing starts until the main image has loaded, so the gallery never
    // competes with it.
    window.luvoraPreloadProductGallery = () => {
      const main = document.querySelector('[data-product-main-image] img');
      if (main && !main.complete) {
        main.addEventListener('load', preloadGallery, { once: true });
        main.addEventListener('error', preloadGallery, { once: true });
        return;
      }
      preloadGallery();
    };

    const preloadGallery = () => {
      const urls = [];
      // Order by distance from the image on screen: the next one right away, then
      // onward through the gallery order (wrapping), then the other metals at this
      // angle (what a metal switch shows first), then the rest of the other metals.
      const thumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));
      const isShown = (thumb) => !thumb.closest('[hidden], .hidden');
      const shown = thumbs.filter(isShown);
      const active = Math.max(0, shown.findIndex((t) => t.classList.contains('product-thumb--active')));
      const ahead = [...shown.slice(active + 1), ...shown.slice(0, active)];
      if (ahead.length) {
        window.luvoraPreloadImageUrls([window.luvoraThumbImageEntry(ahead[0])], { urgent: true });
      }
      const angle = shown[active] ? shown[active].dataset.angle : '';
      const hidden = thumbs.filter((t) => !isShown(t));
      const sameAngle = angle ? hidden.filter((t) => t.dataset.angle === angle) : [];
      [...ahead, ...sameAngle, ...hidden.filter((t) => !sameAngle.includes(t))].forEach((thumb) => {
        urls.push(window.luvoraThumbImageEntry(thumb));
      });
      const map = window.luvoraProductImages;
      if (map && typeof map === 'object') {
        Object.values(map).forEach((entry) => {
          if (!entry) return;
          const items = Array.isArray(entry) ? entry : [entry];
          items.forEach((item) => {
            if (item) urls.push(item);
          });
        });
      }
      if (urls.length) window.luvoraPreloadImageUrls(urls);
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const FADE_MS = 120;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    // Hover images are fetched once their card has faded in, so they never compete with
    // the card photos, and only where a mouse can show them. Not on a metered or slow
    // connection; there the first hover fetches it.
    const hoverPrimers = new WeakMap();
    const primeHoverImages = (frames) => {
      if (!finePointer.matches) return;
      const connection = navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;
      const primers = frames
        .map((frame) => hoverPrimers.get(frame.closest('[data-product-card]')))
        .filter(Boolean);
      if (!primers.length) return;
      const run = () => primers.forEach((prime) => prime());
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 1000 });
      } else {
        setTimeout(run, 0);
      }
    };
    const ease = (p) => (p < 0.5 ? 2 * p * p : 1 - (-2 * p + 2) ** 2 / 2);

    const preloadCard = (card) => {
      if (typeof window.luvoraPreloadProductCard === 'function') {
        window.luvoraPreloadProductCard(card);
      }
    };

    // Cards in view stay hidden until every card image in view has loaded (or failed)
    // and decoded, then all of them fade in on the same frame. Loaded is not enough: a
    // hidden image is only decoded when it first paints, so each one appeared whenever
    // its own decode finished. A card that leaves the view stops counting.
    const inView = new Set();
    const revealInView = () => {
      if (!inView.size) return;
      const imgs = [];
      for (const frame of inView) {
        const img = frame.querySelector('[data-card-img]');
        if (img && !img.complete) return;
        if (img) imgs.push(img);
      }
      const batch = Array.from(inView);
      inView.clear();
      batch.forEach((frame) => frameObserver.unobserve(frame));
      const decoded = Promise.all(imgs.map((img) => img.decode().catch(() => {})));
      // A decode that never settles must not keep the row hidden.
      const timeout = new Promise((resolve) => setTimeout(resolve, 1000));
      Promise.race([decoded, timeout]).then(() => {
        requestAnimationFrame(() => batch.forEach((frame) => frame.removeAttribute('data-card-loading')));
        primeHoverImages(batch);
      });
    };
    const frameObserver =
      'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) inView.add(entry.target);
              else inView.delete(entry.target);
            });
            revealInView();
          })
        : null;

    const watchCardImage = (card) => {
      const frame = card.querySelector('[data-card-loading]');
      if (!frame) return;
      const img = frame.querySelector('[data-card-img]');
      if (!img || !frameObserver) {
        frame.removeAttribute('data-card-loading');
        return;
      }
      img.addEventListener('load', revealInView);
      img.addEventListener('error', revealInView);
      frameObserver.observe(frame);
    };

    const bindProductCards = (root) => {
      const scope = root || document;
      scope.querySelectorAll('[data-product-card]:not([data-luvora-product-card-bound])').forEach((card) => {
        card.setAttribute('data-luvora-product-card-bound', '');
        watchCardImage(card);
        const base = card.querySelector('[data-card-img]');
        const swatches = card.querySelectorAll('[data-swatch-image]');
        const hoverSrc = card.dataset.cardHoverImage || '';
        if (!base || (!swatches.length && !hoverSrc)) return;

        preloadCard(card);

        // One layer per swatch, so a layer never changes src while it is visible.
        // Every layer moves from its current opacity to 0 or 1 on the same curve, so the
        // opacities always sum to 1 and plus-lighter composites a true crossfade.
        const layers = new Map();
        const opacity = new Map([[base, 1]]);
        let frame = 0;
        let wanted = '';

        const fadeTo = (next) => {
          cancelAnimationFrame(frame);
          const from = new Map(opacity);
          const duration = reduceMotion.matches ? 0 : FADE_MS;
          const start = performance.now();
          const step = (now) => {
            const p = duration ? Math.min((now - start) / duration, 1) : 1;
            const e = ease(p);
            from.forEach((value, el) => {
              const v = value + ((el === next ? 1 : 0) - value) * e;
              opacity.set(el, v);
              el.style.opacity = String(v);
            });
            if (p < 1) frame = requestAnimationFrame(step);
          };
          frame = requestAnimationFrame(step);
        };

        const layerFor = (src, priority = 'auto') => {
          if (layers.has(src)) return layers.get(src);
          const layer = base.cloneNode(false);
          ['srcset', 'sizes', 'loading', 'fetchpriority', 'data-card-img'].forEach((a) => layer.removeAttribute(a));
          layer.alt = '';
          layer.setAttribute('aria-hidden', 'true');
          layer.classList.add('product-card-swatch-img');
          layer.style.opacity = '0';
          layer.fetchPriority = priority;
          layer.src = src;
          base.parentNode.appendChild(layer);
          layers.set(src, layer);
          opacity.set(layer, 0);
          return layer;
        };

        const show = (src) => {
          wanted = src;
          const layer = layerFor(src);
          if (layer.complete && layer.naturalWidth) {
            fadeTo(layer);
          } else {
            layer.addEventListener('load', () => wanted === src && fadeTo(layer), { once: true });
          }
        };

        // A card with a hover image rests on it while the pointer is anywhere on the card.
        let inCard = false;
        const rest = () => {
          if (inCard && hoverSrc) {
            show(hoverSrc);
          } else {
            wanted = '';
            fadeTo(base);
          }
        };

        if (hoverSrc) {
          // The layer itself is the prefetch: it is in the DOM, loaded and decoded before
          // the first hover, so the fade starts on the same frame.
          hoverPrimers.set(card, () => {
            const layer = layerFor(hoverSrc, 'low');
            if (layer.decode) layer.decode().catch(() => {});
          });
          card.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            inCard = true;
            show(hoverSrc);
          });
          card.addEventListener('pointerleave', () => {
            inCard = false;
            rest();
          });
        }

        const swatchRow = card.querySelector('[data-swatch-row]');
        if (swatchRow) {
          swatchRow.addEventListener('mouseleave', rest);
        }

        swatches.forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => {
            const newSrc = swatch.dataset.swatchImage;
            if (newSrc) show(newSrc);
          });
        });
      });
    };

    const init = () => {
      bindProductCards(document);
    };

    document.addEventListener('luvora:product-cards-bind', (event) => {
      const detailRoot = event.detail && event.detail.root;
      if (detailRoot) {
        bindProductCards(detailRoot);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-thumb"] && !Shopify.designMode) return;
  try {
    (() => {
    const STAGGER_MS = 70;
    const settled = new WeakSet();
    let waiting = false;

    /*
     * Reveals the first unrevealed thumb in rail order (top, or left on small
     * screens) once its photo is in, then moves on to the next after a short
     * stagger. A thumb still loading holds back every thumb after it. Thumbs of
     * another metal are hidden, so they are skipped, and fade in from this same
     * queue once a metal change shows them. A switch away before they land lets
     * them finish while hidden, with no load event left to come, so the metal
     * sync calls luvoraAdvanceThumbFade after showing them.
     */
    const advance = () => {
      if (waiting) return;
      for (const img of document.querySelectorAll('[data-thumb-fade]')) {
        if (img.hasAttribute('data-thumb-loaded')) continue;
        const item = img.closest('[data-product-thumb-item]');
        if (item && item.hidden) continue;
        if (!settled.has(img) && !img.complete) return;
        waiting = true;
        requestAnimationFrame(() => {
          img.setAttribute('data-thumb-loaded', '');
          setTimeout(() => {
            waiting = false;
            advance();
          }, STAGGER_MS);
        });
        return;
      }
    };

    window.luvoraAdvanceThumbFade = advance;

    const init = () => {
      document.querySelectorAll('[data-thumb-fade]').forEach((img) => {
        const done = () => {
          settled.add(img);
          advance();
        };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
      advance();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-shelves"] && !Shopify.designMode) return;
  try {
    (function () {
    const ROOT_SELECTOR = '[data-product-info-shelves]';
    const DETAILS_SELECTOR = 'details.product-info-shelf';
    const CLIP_CLASS = 'product-info-shelf__panel';
    const BODY_CLASS = 'product-info-shelf__body';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function bindShelf(details) {
      if (details.dataset.shelfMotionBound === '1') return;
      if (prefersReducedMotion()) return;

      const summary = details.querySelector(':scope > summary');
      const clip = details.querySelector(':scope > .'.concat(CLIP_CLASS));
      const body = clip && clip.querySelector(':scope > .'.concat(BODY_CLASS));
      if (!summary || !clip || !body) return;

      details.dataset.shelfMotionBound = '1';

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          clip.style.maxHeight = ''.concat(clip.scrollHeight, 'px');
          clip.getBoundingClientRect();
          clip.style.maxHeight = '0px';

          function onCloseEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onCloseEnd);
            details.open = false;
            clip.style.maxHeight = '';
          }

          clip.addEventListener('transitionend', onCloseEnd);
        } else {
          details.open = true;
          clip.style.maxHeight = '0px';
          var targetH = body.scrollHeight;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              clip.style.maxHeight = ''.concat(targetH, 'px');
            });
          });

          function onOpenEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onOpenEnd);
            if (details.open) clip.style.maxHeight = 'none';
          }

          clip.addEventListener('transitionend', onOpenEnd);
        }
      });
    }

    function initShelves(root) {
      var scope = root || document;
      scope.querySelectorAll(ROOT_SELECTOR + ' ' + DETAILS_SELECTOR).forEach(bindShelf);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initShelves();
      });
    } else {
      initShelves();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector(ROOT_SELECTOR)) {
        initShelves(event.target);
      }
    });
  })();

  (function () {
    const CT_SUFFIX = ' CT';

    function formatCt(value) {
      const num = Number(String(value).replace(',', '.').trim());
      if (Number.isNaN(num)) return String(value).trim() + CT_SUFFIX;
      return num.toFixed(2) + CT_SUFFIX;
    }

    function parseCaratFromLabel(text) {
      if (!text) return null;
      const match = String(text).replace(',', '.').match(/([\d.]+)/);
      return match ? match[1] : null;
    }

    var selectedCarat = null;
    var selectedHallmark = null;
    var selectedStones = null;
    var selectedOptions = [];

    // Rows that show an option's selected label, such as Farge; hidden when
    // the product has no such option.
    function syncOptionRows() {
      document.querySelectorAll('[data-product-spec-option]').forEach(function (row) {
        const name = row.getAttribute('data-product-spec-option');
        const value = row.querySelector('[data-product-spec-option-value]');
        const option = selectedOptions.find(function (s) {
          return s && s.groupName === name;
        });
        if (!value || !option || !option.label) {
          row.hidden = true;
          return;
        }
        value.textContent = option.label;
        row.hidden = false;
      });
    }
    var igiOverride = null;

    // IGI certifies each diamond from 0.30 CT. The largest stone is Carat ÷ its
    // stones when the app counts them, else Carat itself when it is one stone (a
    // main diamond or a loose stone); a total of same-sized stones with no count
    // gets none. A product's override in the app wins. Mirrors certificate.ts.
    function hasIgi(el) {
      if (igiOverride !== null) return igiOverride;
      const carat = Number(selectedCarat);
      if (!carat) return false;
      var stone = 0;
      if (selectedStones) stone = carat / selectedStones;
      else if (el.getAttribute('data-certificate-one-stone') === 'true') stone = carat;
      return Math.round(stone * 1000) >= 300;
    }

    function syncCertificate() {
      document.querySelectorAll('[data-product-spec-certificate]').forEach(function (el) {
        const igi = hasIgi(el);
        var key = igi ? 'data-certificate-igi-luvora' : 'data-certificate-luvora';
        if (el.getAttribute('data-certificate-loose') === 'true') key = 'data-certificate-igi';
        const text = el.getAttribute(key);
        if (text) el.textContent = text;
      });
    }

    // The fineness lasered into the chosen metal, read from the Metall label
    // ("14K GULT GULL", "PLATINA"). The manufacturer note reads it the same way.
    const HALLMARKS = { 9: '375 (9K)', 14: '585 (14K)', 18: '750 (18K)' };

    function hallmarkFromLabel(label) {
      const text = String(label || '').trim();
      if (/^platina$/i.test(text)) return 'PT950';
      const karat = text.match(/^(\d+)K/i);
      return (karat && HALLMARKS[karat[1]]) || null;
    }

    // Stempel shows only on products with a Metall option, once one is picked.
    function syncStamp() {
      document.querySelectorAll('[data-product-spec-stamp]').forEach(function (row) {
        const value = row.querySelector('[data-product-spec-stamp-value]');
        if (!value) return;
        if (!selectedHallmark) {
          row.hidden = true;
          return;
        }
        const template = value.getAttribute('data-product-spec-stamp-template') || '%s';
        value.textContent = template.replace('%s', selectedHallmark);
        row.hidden = false;
      });
    }

    function syncDiamondSpecCarat() {
      const dynamicEls = document.querySelectorAll('[data-product-spec-carat-dynamic]');
      if (!dynamicEls.length) return;

      dynamicEls.forEach(function (el) {
        if (selectedCarat != null) {
          el.textContent = formatCt(selectedCarat);
          return;
        }
        const fallback = el.getAttribute('data-product-spec-carat-fallback');
        if (fallback) {
          el.textContent = formatCt(fallback);
        }
      });
    }

    function initStaticCaratValues(root) {
      const scope = root || document;
      scope.querySelectorAll('[data-product-spec-carat-static]').forEach(function (el) {
        const value = el.getAttribute('data-product-spec-carat-static');
        if (value) el.textContent = formatCt(value);
      });
    }

    // The options app fires `product-options:change` on initial render and on
    // every change, so the Carat group is the single source of truth here.
    document.addEventListener('product-options:change', function (event) {
      const selections = (event.detail && event.detail.selections) || [];
      const carat = selections.find(function (s) {
        return s && s.groupName === 'Carat';
      });
      selectedCarat = carat ? parseCaratFromLabel(carat.label) : null;
      selectedStones = carat && carat.stones ? carat.stones : null;
      igiOverride = event.detail && typeof event.detail.igi === 'boolean' ? event.detail.igi : null;
      const metal = selections.find(function (s) {
        return s && s.groupName === 'Metall';
      });
      selectedHallmark = metal ? hallmarkFromLabel(metal.label) : null;
      selectedOptions = selections;
      window.requestAnimationFrame(function () {
        syncDiamondSpecCarat();
        syncStamp();
        syncCertificate();
        syncOptionRows();
      });
    });

    function initDiamondSpecCarat(root) {
      var scope = root || document;
      initStaticCaratValues(scope);
      if (!scope.querySelector('[data-product-spec-carat-dynamic]')) return;
      syncDiamondSpecCarat();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initDiamondSpecCarat();
      });
    } else {
      initDiamondSpecCarat();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) initDiamondSpecCarat(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-field"] && !Shopify.designMode) return;
  try {
    (function () {
    // Delegated, so a field in the popup and one on the page share it.
    function clearButton(input) {
      return input.parentElement.querySelector('[data-search-field-clear]');
    }

    document.addEventListener('input', function (event) {
      var input = event.target.closest && event.target.closest('[data-search-field-input]');
      if (!input) return;
      var clear = clearButton(input);
      if (clear) clear.classList.toggle('hidden', input.value === '');
    });

    document.addEventListener('click', function (event) {
      var clear = event.target.closest && event.target.closest('[data-search-field-clear]');
      if (!clear) return;
      var input = clear.parentElement.querySelector('[data-search-field-input]');
      input.value = '';
      clear.classList.add('hidden');
      input.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spesialdesign-upload"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-spesialdesign-upload]');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var input = root.querySelector('[data-spesialdesign-upload-input]');
    var drop = root.querySelector('[data-spesialdesign-upload-drop]');
    var list = root.querySelector('[data-spesialdesign-upload-list]');
    var status = root.querySelector('[data-spesialdesign-upload-status]');
    var errorEl = root.querySelector('[data-spesialdesign-upload-error]');
    var urlsEl = root.querySelector('[data-spesialdesign-upload-urls]');
    var idsEl = root.querySelector('[data-spesialdesign-upload-ids]');

    var maxFiles = Number(root.dataset.maxFiles) || 5;
    var maxBytes = Number(root.dataset.maxBytes) || 10485760;
    var allowed = ['image/png', 'image/jpeg', 'image/webp', 'image/avif'];
    var uploaded = [];
    var pending = 0;

    function sync() {
      urlsEl.value = uploaded
        .map(function (item) {
          return item.url;
        })
        .join('\n');
      idsEl.value = uploaded
        .map(function (item) {
          return item.id;
        })
        .join(',');
      list.classList.toggle('hidden', uploaded.length === 0);
      list.classList.toggle('grid', uploaded.length > 0);
    }

    function showError(message) {
      errorEl.textContent = message || '';
      errorEl.classList.toggle('hidden', !message);
    }

    function showStatus(message) {
      status.textContent = message || '';
      status.classList.toggle('hidden', !message);
    }

    function render() {
      list.textContent = '';
      uploaded.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'relative';

        var img = document.createElement('img');
        img.src = item.url;
        img.alt = '';
        img.loading = 'lazy';
        img.className =
          'spesialdesign-upload__thumb w-full rounded-none border border-luvora-sage/50';
        li.appendChild(img);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className =
          'absolute right-1 top-1 rounded-full bg-luvora-ink/80 px-2 py-0.5 text-xs leading-tight text-white';
        remove.textContent = '×';
        remove.setAttribute('aria-label', root.dataset.msgRemove || 'Remove');
        remove.addEventListener('click', function () {
          uploaded = uploaded.filter(function (entry) {
            return entry.id !== item.id;
          });
          sync();
          render();
        });
        li.appendChild(remove);

        list.appendChild(li);
      });
      sync();
    }

    /* The app replies with the CDN URL and the id the submit post needs. */
    function upload(file) {
      var body = new FormData();
      body.append('file', file);
      pending += 1;
      showStatus(root.dataset.msgUploading || '');

      return fetch(root.dataset.endpoint, { method: 'POST', body: body })
        .then(function (response) {
          return response.json().catch(function () {
            return { ok: false };
          });
        })
        .then(function (data) {
          if (!data || !data.ok) throw new Error((data && data.error) || 'failed');
          uploaded.push({ id: data.fileId, url: data.url });
          render();
        })
        .catch(function () {
          showError(root.dataset.msgFailed);
        })
        .then(function () {
          pending -= 1;
          if (pending === 0) showStatus('');
        });
    }

    function accept(files) {
      showError('');
      Array.prototype.slice.call(files).forEach(function (file) {
        if (uploaded.length + pending >= maxFiles) {
          showError(root.dataset.msgMax);
          return;
        }
        if (allowed.indexOf(file.type) === -1) {
          showError(root.dataset.msgType);
          return;
        }
        if (file.size > maxBytes) {
          showError(root.dataset.msgSize);
          return;
        }
        upload(file);
      });
    }

    input.addEventListener('change', function () {
      accept(input.files);
      /* Let the same file be chosen again after it is removed. */
      input.value = '';
    });

    /*
     * A depth counter rather than a plain dragleave. The label wraps several
     * child elements, and dragging across them fires leave then enter, which
     * makes a highlight toggled on those events flicker.
     */
    var dragDepth = 0;

    function setDragging(on) {
      drop.classList.toggle('spesialdesign-upload__drop--active', on);
    }

    drop.addEventListener('dragenter', function (event) {
      event.preventDefault();
      dragDepth += 1;
      setDragging(true);
    });

    drop.addEventListener('dragover', function (event) {
      /* Without this the browser rejects the drop and opens the file itself. */
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
    });

    drop.addEventListener('dragleave', function () {
      dragDepth = Math.max(0, dragDepth - 1);
      if (dragDepth === 0) setDragging(false);
    });

    drop.addEventListener('drop', function (event) {
      event.preventDefault();
      dragDepth = 0;
      setDragging(false);
      if (event.dataTransfer && event.dataTransfer.files) {
        accept(event.dataTransfer.files);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
